import { createColumnHelper } from '@tanstack/react-table'
import { NavLink } from 'react-router-dom'
import type { PurchaseReportDetails } from '../../../../../../types'
import { formatCurrency } from '../../../utils/formatCurrency'

type DataProps = {
  options: { year: string; month: string }
}
export default function purchaseReportDetailsColumns({ options }: DataProps) {
  const columnHelper = createColumnHelper<PurchaseReportDetails>()
  return [
    columnHelper.accessor('regNo', {
      id: 'regNo',
      enableSorting: false,
      header: 'Reg.nr.',
      cell: ({ row, getValue }) => (
        <NavLink
          className="flex w-fit text-interaction hover:underline hover:text-interactionHover"
          to={`/reports/purchase/${options.year}-${options.month}/${row.original.accountNo}?regNo=${getValue()}`}
        >
          {getValue()}
        </NavLink>
      ),
    }),
    columnHelper.accessor('vehicleID', {
      id: 'vehicleID',
      enableSorting: false,
      header: 'Kjøretøy-ID',
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('invoiceGroupingDescription', {
      id: 'invoiceGroupingDescription',
      header: 'Fakturagruppe',
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('carDescription', {
      id: 'carDescription',
      enableSorting: false,
      header: 'Objekt',
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('driverName', {
      id: 'driverName',
      enableSorting: false,
      meta: { alignmentType: 'string' },
      header: 'Sjåfør',
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('amountincVAT', {
      id: 'amountincVAT',
      meta: {
        mobileFooterLabel: 'Sum beløp',
        alignmentType: 'right',
      },
      header: 'Beløp',
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + ((row.getValue('amountincVAT') as number) || 0), 0)
        return formatCurrency(total)
      },

      cell: (row) => formatCurrency(row.getValue()) || '',
    }),
  ]
}
